// extracted by mini-css-extract-plugin
export default {"page_header_image":"StretchHeaderImage_page_header_image__JfFLG"};